let debounceTimer = null;

export default function debounce(func, time = 200) {
    return () => {
        let context = this;
        let args = arguments;

        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(() => {
            func.apply(context, args);
        }, time);
    };
}